import React from 'react';
import './TcsoChecklistScreen.css';
import { OvoBullet } from '../common/bullet/OvoBullet';
import { TcsoDualFuelScreen, useTcsoDualFuelScreenContext } from '../../context/TcsoDualFuelScreenContext';
import { useHomePageContext } from '../../context/HomePageContext';
import { useFlags } from 'launchdarkly-react-client-sdk';

export default function TcsoDualFuelChecklistScreen() {
  const { setTcsoDualFuelScreenInputs } = useTcsoDualFuelScreenContext();
  const { homePageState, setHomePageState } = useHomePageContext();

  const { enableAutomatedTcsoDualFuel } = useFlags();

  const startTcsoDualFuel = () => {
    setTcsoDualFuelScreenInputs({ tcsoDualFuelScreen: TcsoDualFuelScreen.TCSO_DUAL_FUEL_METER_DETAILS_SCREEN });

    setHomePageState({
      ...homePageState,
      automationInProgress: true,
    });
  };

  return (
    <div className="tcsoScreenContainer">
      {enableAutomatedTcsoDualFuel && (
        <div className="tcsoBody">
          <div className={'sectionWrapper'}>
            <div className={'sectionTextNote'}>
              You’re about to perform a TCSO for Dual Fuel. <span className={'ovoGreen'}>Before you start, confirm:</span>
            </div>
            <div className={'marginTop12'}></div>
            <OvoBullet text={'Old hub removed and kept away or placed in your vehicle'}></OvoBullet>
            <OvoBullet text={'New hub successfully birthed'}></OvoBullet>
          </div>
        </div>
      )}
      {enableAutomatedTcsoDualFuel && (
        <div className={'tcsoFooter'}>
          <button className={'tcsoButton'} onClick={startTcsoDualFuel}>
            All set, start TCSO
          </button>
        </div>
      )}
    </div>
  );
}
